import { NgClass } from '@angular/common'
import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { JoinPipe } from '../../../../shared/pipes/join.pipe'
import type { Requirement } from '../../util/validators'

@Component({
  selector: 'dhp-password-requirements',
  templateUrl: './password-requirements.component.html',
  styleUrls: ['./password-requirements.component.scss'],
  imports: [NgClass, TranslatePipe, JoinPipe],
})
export class PasswordRequirementsComponent {
  readonly requirements = input<Requirement[]>([])
}
